import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import SearchComponent from '../../PricingHub/SearchComponent';

class VoiceOperatorCallTypeSummarySearchForm extends SearchComponent {
  searchInputs = [
    // {
    //   label: 'label.callType',
    //   name: 'usageType',
    //   fa: 'fa fa-external-link',
    // },
    {
      label: 'label.startDate',
      name: 'startDate',
      type: 'datetime',
      required: true,
      defaultValue: moment(). startOf('month').format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      label: 'label.endDate',
      name: 'endDate',
      type: 'datetime',
      required: true,
      defaultValue: moment().endOf('month').format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      label: 'label.operatorId',
      name: 'operatorId',
      fa: 'fa fa-external-link',
    },
    {
      label: 'label.direction',
      name: 'direction',
      type: 'select',
      tOptions: 'selections:usageDirection',
      isClearable: true,
    },
  ];

  btnSpan = 'col-md-12';
}

VoiceOperatorCallTypeSummarySearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

VoiceOperatorCallTypeSummarySearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(VoiceOperatorCallTypeSummarySearchForm);
